import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kmxwcblyatvqhctgncmp.supabase.co'; // process.env.SUPABASE_URL; // Ensure environment variables are prefixed with REACT_APP_ in React projects
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtteHdjYmx5YXR2cWhjdGduY21wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTE5MzkxMDksImV4cCI6MjAyNzUxNTEwOX0.guJNgkjuGhGEnGHt7zbt2jIvqRwV9frXtI-_rkZvhOE';  // process.env.SUPABASE_KEY;

console.log(supabaseUrl)

export const supabase = createClient(supabaseUrl, supabaseKey);
